import { render } from "./InventoryRooms.vue?vue&type=template&id=9c87b26c&scoped=true"
import script from "./InventoryRooms.vue?vue&type=script&lang=js"
export * from "./InventoryRooms.vue?vue&type=script&lang=js"

import "./InventoryRooms.vue?vue&type=style&index=0&id=9c87b26c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c87b26c"]])

export default __exports__